import React from 'react';
import { Navigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { useAppContext } from '../lib/store';
export function LoginPage() {
  const {
    auth,
    login
  } = useAppContext();
  if (auth.isAuthenticated) {
    return <Navigate to="/" replace data-id="element-342" />;
  }
  return <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden" data-id="element-343">
      {/* Animated gradient background */}
      <div className="absolute inset-0 -z-10" style={{
      background: 'linear-gradient(-45deg, #0f2b5b, #1a4a8a, #2d6bc4, #e8573a, #1a4a8a, #0f2b5b)',
      backgroundSize: '400% 400%',
      animation: 'gradientShift 15s ease infinite'
    }} data-id="element-344" />
      {/* Subtle overlay for readability */}
      <div className="absolute inset-0 -z-10 bg-black/10" data-id="element-345" />

      <div className="w-full max-w-md" data-id="element-346">
        <div className="flex justify-center mb-8" data-id="element-347">
          <img src="https://cdn.magicpatterns.com/uploads/fwae64AkjzR1PZNPwPqUJx/simtech_(1).svg" alt="Simtech" className="h-16 drop-shadow-lg brightness-0 invert" data-id="element-348" />
        </div>

        <Card className="shadow-2xl border-0 backdrop-blur-sm bg-white/95 p-4" data-id="element-349">
          <CardHeader className="text-center space-y-3 pt-6 pb-8 px-6" data-id="element-350">
            <CardTitle className="text-2xl" data-id="element-351">Prijava v sistem</CardTitle>
            <CardDescription data-id="element-352">
              Za dostop do aplikacije se prijavite z vašim službenim računom.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4 px-6 pb-8" data-id="element-353">
            <Button className="w-full h-12 text-base" variant="outline" onClick={() => login('Google')} data-id="element-354">
              <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-355">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-356" />
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-357" />
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-358" />
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-359" />
              </svg>
              Prijava z Google računom
            </Button>
          </CardContent>
        </Card>

        <p className="text-center text-sm text-white/70 mt-8" data-id="element-360">
          Sistem za upravljanje delovnih nalogov &copy;{' '}
          {new Date().getFullYear()}
        </p>
      </div>
    </div>;
}